module.exports = __webpack_public_path__ + "static/media/Cornell University.6500aadc.jpg";